// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-dropdownmenu_default__1icdy","hide":"idt-dropdownmenu_hide__1az8j","top":"idt-dropdownmenu_top__zbqsw","bottom":"idt-dropdownmenu_bottom__3aa6b"};